import { render } from "./AssignedGroups.vue?vue&type=template&id=c34219a6&scoped=true"
import script from "./AssignedGroups.vue?vue&type=script&lang=js"
export * from "./AssignedGroups.vue?vue&type=script&lang=js"

import "./AssignedGroups.vue?vue&type=style&index=0&id=c34219a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c34219a6"]])

export default __exports__